import { useEffect, useState } from 'react';
import { getImportHaccpAgent } from '../../../utils/api/aggiornamentoGestioneOperativaApi';

/**
 * Reads whether a configuration from HACCP Agent has been imported into a
 * Gestione Operativa, on mount and again on every new `ricaricaToken`.
 *
 * Returns `{ stato: 'caricamento' }` until the read settles, then
 * `{ stato: 'assente' }`, `{ stato: 'presente', importazione }` or
 * `{ stato: 'errore' }`. `assente` is never inferred from a read that did not
 * succeed: it would invite a first import over a configuration that may already
 * exist. Without an id there is nothing to read, and the state stays
 * `caricamento`. A read that settles after the id has changed is ignored.
 */
const useImportHaccpAgent = (
  aggiornamentoGestioneOperativaId,
  ricaricaToken,
) => {
  const [lettura, setLettura] = useState({ stato: 'caricamento' });

  useEffect(() => {
    let attivo = true;
    setLettura({ stato: 'caricamento' });
    if (aggiornamentoGestioneOperativaId == null) {
      return undefined;
    }
    getImportHaccpAgent(aggiornamentoGestioneOperativaId)
      .then((importazione) => {
        if (!attivo) return;
        setLettura(
          importazione
            ? { stato: 'presente', importazione }
            : { stato: 'assente' },
        );
      })
      .catch((error) => {
        if (!attivo) return;
        console.error(error);
        setLettura({ stato: 'errore' });
      });
    return () => {
      attivo = false;
    };
  }, [aggiornamentoGestioneOperativaId, ricaricaToken]);

  return lettura;
};

export default useImportHaccpAgent;
